import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { cn } from "../utils/styleHelper";
function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
    return /*#__PURE__*/ _jsx(DayPicker, {
        showOutsideDays: showOutsideDays,
        className: cn("p-3", className),
        classNames: {
            months: "flex flex-col sm:flex-row space-y-4 sm:mx-8 sm:space-y-0",
            month: "space-y-4",
            month_caption: "flex justify-center pt-1 relative items-center",
            caption_label: "text-sm font-medium",
            nav: "space-x-1 flex items-center",
            button_previous: cn("h-9 w-9 bg-transparent p-2 opacity-50 hover:opacity-100 inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors absolute left-1", "hover:bg-gray-100 hover:text-gray-900", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2", "disabled:pointer-events-none disabled:opacity-50"),
            button_next: cn("h-9 w-9 bg-transparent p-2 opacity-50 hover:opacity-100 inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors absolute right-1", "hover:bg-gray-100 hover:text-gray-900", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2", "disabled:pointer-events-none disabled:opacity-50"),
            month_grid: "w-full border-collapse space-y-1",
            weekdays: "flex",
            weekday: "text-gray-500 rounded-md w-9 font-normal text-[0.8rem]",
            week: "flex w-full mt-2",
            day: cn("h-9 w-9 text-center text-sm p-0 relative inline-flex items-center justify-center rounded-md font-normal transition-colors", "hover:bg-gray-100 hover:text-gray-900", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2", "aria-selected:opacity-100"),
            day_button: cn("h-9 w-9 p-0 font-normal"),
            selected: "bg-navy-90 text-white hover:bg-navy-90 hover:text-white focus:bg-navy-90 focus:text-white",
            today: "bg-gray-100 text-gray-900 font-semibold",
            outside: "text-gray-500 opacity-50 aria-selected:bg-gray-100/50 aria-selected:text-gray-500 aria-selected:opacity-30",
            disabled: "text-gray-500 opacity-50 cursor-not-allowed",
            range_middle: "aria-selected:bg-gray-100 aria-selected:text-gray-900 rounded-none",
            range_start: "rounded-l-md",
            range_end: "rounded-r-md",
            hidden: "invisible",
            ...classNames
        },
        components: {
            Chevron: ({ orientation })=>{
                if (orientation === "left") {
                    return /*#__PURE__*/ _jsx(ChevronLeft, {
                        className: "h-4 w-4"
                    });
                }
                return /*#__PURE__*/ _jsx(ChevronRight, {
                    className: "h-4 w-4"
                });
            }
        },
        ...props
    });
}
Calendar.displayName = "Calendar";
export { Calendar };
